import { type ObjectValuesUnionType } from '../utils/typing';

/* BASKET MODE */
export const BasketModes = Object.freeze({
  SIMPLE: 'SIMPLE',
  COMBINED: 'COMBINED',
  SYSTEM: 'SYSTEM',
});
export type BasketMode = ObjectValuesUnionType<typeof BasketModes>;

/* BASKET STATUS */
export const BasketStatuses = Object.freeze({
  OK: 'OK',
  PENDING: 'PENDING',
  ERROR: 'ERROR',
  VALIDATED: 'VALIDATED',
  REJECTED: 'REJECTED',
  WAITING: 'WAITING',
});
export type BasketStatus = ObjectValuesUnionType<typeof BasketStatuses>;

/* BASKET ITEM STATUS */
export const BasketItemStatuses = Object.freeze({
  OK: 'OK',
  PENDING: 'PENDING',
  VALIDATED: 'VALIDATED',
  WAITING: 'WAITING',
  ERROR: 'ERROR',
  REJECTED: 'REJECTED',
});
export type BasketItemStatus = ObjectValuesUnionType<typeof BasketItemStatuses>;

/* BETSLIP ERROR CODE */
export const BetslipErrorCodes = Object.freeze({
  ACCESS_DENIED: 1,
  BAD_REQUEST: 2,
  MAINTENANCE: 3,
  SAME_BET: 4,
  LOCK_FAILED: 5,

  NO_POSSIBLE_WININGS: 7,
  INCORRECT_ODD: 8,
  DB_ERROR: 11,
  NOT_ENOUGH_MONEY: 100,
  TOO_MANY_LINES: 101,
  BETSLIP_DETAIL_NO_ERROR: 200,
  BETSLIP_DETAIL_INCOMPATIBLE_BETS: 203,
  BETSLIP_DETAIL_INCOMPATIBLE_OUTRIGHT: 204,
  BETSLIP_DETAIL_BET_SUSPENDED: 205,
  BETSLIP_DETAIL_BET_STOPPED: 206,
  BETSLIP_DETAIL_ODDS_CHANGED_INCREASE: 211,
  BETSLIP_DETAIL_ODDS_CHANGED_DECREASE: 212,
  ODDS_CHANGED: 300,
  INCOMPATIBLE_BETS: 303,
  INCOMPATIBLE_OUTRIGHT: 304,
  BET_SUSPENDED: 305,
  BET_STOPPED: 306,
  ODDS_UNDER_LIMIT: 310,
  MAXIMUM_BET_AMOUNT_REACHED: 314,

  // NOTE: erreur interne client si la mise est à 0
  AMOUNT: 3110,
  AMOUNT_UNDER_LIMIT: 311,
  AMOUNT_OVER_LIMIT: 312,
  NEED_MANUAL_VALIDATION: 313,
  MODERATOR_REACHED: 400,
  DAILY_MODERATOR_REACHED: 401,
  WEEKLY_MODERATOR_REACHED: 402,
  MONTHLY_MODERATOR_REACHED: 403,
  SYSTEM_TOO_MANY_BANKERS: 500,
  SYSTEM_TOO_MANY_BETSLIP: 501,
  SYSTEM_TOO_FEW_COMBINATIONS: 502,
  INVALID_FREEBET_ID: 700,
  INVALID_FREEBET_AMOUNT: 701,
  NOT_ENOUGH_FREEBET: 702,
  INVALID_BOOSTER_ID: 710,
  LIMITED_TO_FREEBETS: 800,
  TRADER: 900,
  BET_MODIFICATION_UNAVAILABLE: 1200,
  BET_MODIFICATION_UNAVAILABLE_WITH_FREE_BETS: 1201,

  // KL
  KOH_LANTA: 2000,

  // GR
  GIFT_RACE: 3000,

  // MP
  MONOPOLY: 4000,

  // BOOM
  BOOM: 5000,

  // MyMatch
  MYMATCH_PROBLEM: 10000,
  MYMATCH_UNAVAILABLE_500: 10500,
  MYMATCH_UNAVAILABLE_1: 10400,
  MYMATCH_INCOHERENT_SELECTIONS: 10401,
  MYMATCH_TOO_MANY_SELECTIONS: 10402,
  MYMATCH_SELECTION_UNAVAILABLE: 10403,
});
export type BetslipErrorCode = ObjectValuesUnionType<typeof BetslipErrorCodes>;

export const OddsChanges = Object.freeze({
  UP: 'UP',
  DOWN: 'DOWN',
});
export type OddsChange = ObjectValuesUnionType<typeof OddsChanges>;
